<template>
  <nv-page header="Connected Devices Rule">
    <template slot="toolbar">
      <v-spacer />
      <nv-btn type="back" />
      <nv-btn v-if="$auth.hasPermissions('ant.discovery')" type="edit" @click="openForm(item)" />
    </template>
    <v-card class="pa-4" data-cy="ottm-rule-details">
      <v-row>
        <nv-show cols="12" sm="6" header="Rule">{{ item.pattern }}</nv-show>
        <nv-show cols="12" sm="3" no-placeholder header="Level">
          <tree-item :tree-id="item.tree_id" />
        </nv-show>
        <nv-show cols="12" sm="3" no-placeholder header="market">
          <CountryBadge :country="resolveCountryCode(item.localization)" />
        </nv-show>
        <nv-show cols="12" sm="6" header="Updated By">{{ item.updated_by }}</nv-show>
        <nv-show cols="12" sm="3" header="Property">{{ item.property | humanize }}</nv-show>
        <nv-show cols="12" sm="3" header="Status">{{ item.status | humanize }}</nv-show>
      </v-row>
    </v-card>
    <v-card class="mt-4 elevation-2" data-cy="tabs-card">
      <v-tabs v-model="tabs" slider-color="accent">
        <v-tab data-cy="localised-rules-tab">
          Localised Rules
        </v-tab>
        <v-tab data-cy="history-tab">
          History
        </v-tab>
      </v-tabs>
      <v-tabs-items v-if="item.id != null" v-model="tabs">
        <v-tab-item>
          <localised-patterns-tab
            :id="item.id"
            kind="ottm"
            :country-code="item.localization"
            data-cy="localised-patterns-pane"
          />
        </v-tab-item>
        <v-tab-item>
          <rules-history-tab
            :id="item.id"
            :key="JSON.stringify(item)"
            product="ottm"
            data-cy="history-pane"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <rules-edit-form v-model="form.show" :editing="form.edit" @saved="fetchData" />
  </nv-page>
</template>

<script>
import HTTP from '@/api/ant.js';
import TreeItem from '@/components/cls/TreeItem.vue';
import RulesHistoryTab from '@/components/cls/RulesHistoryTab.vue';
import RulesEditForm from '@/components/cls/connected-devices/RulesEditForm.vue';
import LocalisedPatternsTab from '@/components/mv/LocalisedPatternsTab.vue';
import CountryBadge from '@/components/CountryBadge';
import { resolveCountryCode } from '@/helpers/filters';

export default {
  components: { RulesEditForm, RulesHistoryTab, TreeItem, CountryBadge, LocalisedPatternsTab },
  data: () => ({
    item: {},
    tabs: 0,
    form: {
      show: false,
      edit: null,
    },
  }),
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      HTTP.get(`/ottm/rules/${this.$route.params.ruleId}`).then(({ data }) => {
        this.item = data;
      });
    },
    openForm(edit) {
      this.form.edit = edit;
      this.form.show = true;
    },
    resolveCountryCode,
  },
};
</script>
